import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from "react"
import { YhBox } from "@/erp_subpackage/components/YhBox"
import { Table } from 'antd'
import { usePrebookModel } from "../prebookModel";
import YhIcon from "@/components/pubIcon"

export const Material = ({ modeKey, mode, rowInfo, dispatch, formRef }) => {
    const { t } = useTranslation();
    const { getMaterialList, setMaterialList } = usePrebookModel();
    const [staticInfo, setStaticInfo] = useState({ materialAmount: 0, materialQuantity: 0, enough: 0, notenough: 0 })

    useEffect(() => {

        let materialAmount = 0;
        let enough = 0;
        let notenough = 0;
        getMaterialList(mode) && getMaterialList(mode).forEach(e => {
            materialAmount = Number(materialAmount) + Number(e.actualAmount);
            materialAmount = materialAmount.toFixed(2);

            enough += e.availableStock < e.materialNumber ? 0 : 1;
            notenough += e.availableStock < e.materialNumber ? 1 : 0;
        });
        setStaticInfo({ materialAmount: materialAmount, materialQuantity: getMaterialList(mode) && getMaterialList(mode).length, enough: enough, notenough: notenough });
    }, [getMaterialList(mode)])

    const columns = [
        {
            title: t(`ordersManage.convert.Material.序号`),
            width: 50,
            align: "center",
            render: (t, r, i) => i + 1
        },
        {
            title: t(`ordersManage.convert.Material.商品编号`),
            width: 200,
            align: "center",
            dataIndex: "materialCode",
            sorter: (a, b) => {
                return a.materialCode.charCodeAt(0) - b.materialCode.charCodeAt(0)
            }
        },
        {
            title: t(`ordersManage.convert.Material.商品名称`),
            width: 200,
            align: "center",
            dataIndex: "materialName",
            sorter: (a, b) => {
                return a.materialName?.localeCompare(b.materialName, 'zh-Hans-CN', { sensitivity: 'accent' })
            }
        },
        {
            title: t(`ordersManage.convert.Material.品牌`),
            width: 120,
            align: "center",
            dataIndex: "brandName",
        },
        {
            title: t(`ordersManage.convert.Material.单位`),
            width: 120,
            align: "center",
            dataIndex: "unitName",
        },
        {
            title: t(`ordersManage.convert.Material.当前库存`),
            width: 120,
            align: "center",
            dataIndex: "availableStock",
        },
        {
            title: t(`ordersManage.convert.Material.数量`),
            width: 120,
            align: "center",
            dataIndex: "materialNumber",
        },
        {
            title: t(`ordersManage.convert.Material.是否满足`),
            width: 150,
            align: "center",
            dataIndex: "enough",
            defaultSortOrder: 'ascend',
            render: (text, record) => {
                return record.availableStock < record.materialNumber ? <span style={{ color: 'red' }}> {t(`ordersManage.convert.Material.否`)}</span> : t(`ordersManage.convert.Material.是`);
            },
            sorter: (a, b) => {
                return a.availableStock - a.materialNumber
            }
        },
        {
            title: t(`ordersManage.convert.Material.销售单价`),
            width: 120,
            align: "center",
            dataIndex: "salePrice",
        },
        {
            title: t(`ordersManage.convert.Material.总计`),
            width: 120,
            align: "center",
            dataIndex: "materialAmount",
        },
        {
            title: t(`ordersManage.convert.Material.优惠`),
            width: 120,
            align: "center",
            dataIndex: "preferentialAmount",
        },
        {
            title: t(`ordersManage.convert.Material.折扣`),
            width: 120,
            align: "center",
            dataIndex: "materialDiscount",
        },
        {
            title: t(`ordersManage.convert.Material.总金额`),
            width: 120,
            align: "center",
            dataIndex: "actualAmount",
        },
        {
            title: t(`ordersManage.convert.Material.备注`),
            width: 120,
            align: "center",
            dataIndex: "remark",
        },
        {
            title: t(`ordersManage.convert.Material.操作`),
            width: 120,
            align: "center",
            dataIndex: "operation",
            render: (_, record) => {
                return <YhIcon type="icon-guanbi" style={{ color: "#D81E06", cursor: "pointer" }} onClick={() => deleteOne(record)} />
            },
        },

    ]

    const deleteOne = (record) => {
        let list = getMaterialList(mode).filter((item) => item.id !== record.id);
        setMaterialList(mode, list);
    };

    const action =
        <>
            <div style={{ display: 'inline-block' }}> {t(`ordersManage.convert.Material.满足`)}：{staticInfo.enough}t(`ordersManage.convert.Material.项`)</div>
            <div style={{ display: 'inline-block', marginLeft: 20 }}> {t(`ordersManage.convert.Material.不满足`)}：<span style={{ color: 'red' }}>{staticInfo.notenough}t(`ordersManage.convert.Material.项`)</span></div>
        </>

    return (
        <YhBox title= {t(`ordersManage.convert.Material.维修用料`)} rightChildren={action} style={{ marginBottom: '10px' }}>
            <div style={{ height: 0, position: 'relative', float: 'left', top: -35, left: 100, }}>
                 {t(`ordersManage.convert.Material.总金额`)}￥<span style={{ color: 'red', fontWeight: 'bold' }}>{staticInfo.materialAmount}</span> {t(`ordersManage.convert.Material.元`)}（{staticInfo.materialQuantity}t(`ordersManage.convert.Material.项`)）
            </div>
            <Table
                size="small"
                columns={columns}
                dataSource={getMaterialList(mode)}
                rowKey={(record) => record.id}
                pagination={{
                    showQuickJumper: true,
                    showSizeChanger: false,
                    showTotal: () => `${t(`ordersManage.convert.Material.共`)}${getMaterialList(mode).length}${t(`ordersManage.convert.Material.条`)}`,
                    position: ["bottomCenter"],
                }}
            />
        </YhBox>
    )
}
